import appCONST from './../constants/app.constants';

export default function ApplicationConfig(
    $compileProvider,
    $locationProvider,
    $httpProvider,
    localStorageServiceProvider,
    AnalyticsProvider,
    uiGmapGoogleMapApiProvider
) {
    'ngInject';

    const isPreProduction = window.location.host.match(/^staging/); // eslint-disable-line
    const isProduction = window.location.host.match(/^interactive/); // eslint-disable-line
    const debugInfoEnabled = !(isPreProduction || isProduction) || isForcedDebugModeEnabled();
    $compileProvider.debugInfoEnabled(debugInfoEnabled);

    $locationProvider.html5Mode(false);
    $httpProvider.useApplyAsync(true);
    AnalyticsProvider.setAccount(appCONST.googleAnalyticsTrackingCode);
    AnalyticsProvider.setPageEvent('$stateChangeSuccess');
    localStorageServiceProvider.setStorageType('localStorage');
    _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;

    uiGmapGoogleMapApiProvider.configure({
        key: appCONST.googleApiKey,
        v: '3.45', //eslint-disable-line
        libraries: 'places,visualization',
    });
}

function isForcedDebugModeEnabled() {
    const {localStorage} = window;
    const ENABLE_FORCED_DEBUG_MODE = 'enable-forced-debug-mode';
    return !!(localStorage && localStorage.getItem(ENABLE_FORCED_DEBUG_MODE));
}



// WEBPACK FOOTER //
// ./src/app/configs/app.config.js